// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2zdk8","gfeWrapper":"CalendarEvent_gfeWrapper__1v_-C"};